<template>
    <div id="agPOSTGISConn">
      <b-input-group size="md" prepend="Port">
      <b-input type="text" v-model="connection.port" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    </div>
  </template>
  
  
  <script>
  // components
  
  // server
  
  // modules
  
  export default {
    name: "ag-postgis-conn",
  
    props: {
      isReadonly: Boolean,
      connection: Object,
    },
  
    data() {
      return {
      };
    },
  
    computed: {
  
    },
  
    methods: {
  
      // UI Events
  
      // other
  
      reset() {
        
      },
  
      prepareForSave() {
        
      },
  
    }
  };
  </script>
  
  
  <style scoped lange="css">
  
  </style>


// WEBPACK FOOTER //
// src/components/connection/POSTGISConnection.vue